import { render, staticRenderFns } from "./EmployeeRegistryFileDocumentErrors.vue?vue&type=template&id=78d34afb&"
import script from "./EmployeeRegistryFileDocumentErrors.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryFileDocumentErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports